import React, { Component } from 'react';
import FAQSubCategory from '../../../../src/models/FAQSubCategory';
import FAQSubCategoryMapper from '../../../../src/mappers/FAQSubCategory.mapper';
import FAQArticle from '../../../../src/models/FAQArticle';
import FAQArticleView from '../../../../src/views/components/FAQArticleView';

type FAQSubCategoryViewProps = {
    showTitle: boolean,
    subCategory: FAQSubCategory,
}

export default class FAQSubCategoryView extends Component<FAQSubCategoryViewProps, any> {
    public render() {
        return (
            <div className="my-3">
                {
                    this.props.showTitle
                        ? <h3 className="label">{this.props.subCategory.title}</h3>
                        : null
                }
                <h4 className='sr-only' aria-live='polite'>{this.props.subCategory.articles.length} questions for {this.props.subCategory.title} found</h4>

                {
                    this.props.subCategory.articles.map((article: FAQArticle, index: number) => {

                        const id = "faqArticle_" + index + "_" + this.props.subCategory.title.toLowerCase().replace(/ /g, '_');
                        return (
                            <FAQArticleView article={article} key={"faqArticle_" + index} id={id} />
                        );
                    })
                }
            </div>
        );
    }
}